<template>
  <div
    class="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen
   pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-black bg-opacity-60
     transition-opacity"
        aria-hidden="true"
      ></div>
      <span
        class="hidden sm:inline-block
    sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >
      <div
        class="inline-block align-bottom bg-white rounded-lg text-left
     overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle
      sm:max-w-lg sm:w-full"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 text-center">
          <h3
            class="text-lg leading-6 font-medium
            text-gray-900"
            id="modal-title"
          >
            Edit Form
          </h3>
          <div class="sm:flex sm:items-start mt-3 sm:mt-0 sm:ml-4 sm:text-left">
            <form
              class="mt-2 w-full"
              ref="form"
              @submit.prevent="getFormValues"
            >
              <div
                v-for="(r, i) in row"
                :key="`item-${i}`"
                :hidden="hide && hide.has(headers[i])"
              >
                {{ headers[i] }}
                <t-input
                  :value="r"
                  :name="headers[i]"
                  v-if="!values || !(headers[i] in values)"
                />
                <div v-else>
                  <select
                    :value="r"
                    :name="headers[i]"
                    v-if="headers[i] in values"
                  >
                    <option
                      v-for="option of values[headers[i]]"
                      :value="option[0]"
                    >
                      {{ option[1] }}
                    </option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            class="w-full inline-flex justify-center rounded-md
           focus-within:border border-transparent shadow-sm px-4 py-2
          bg-green-600 text-base font-mediumtext-white hover:bg-green-700
          focus:outline-none focus:ring-2 focus:ring-offset-2 text-white
           focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
            v-on:click="submitForm()"
          >
            Save
          </button>
          <button
            type="button"
            class="mt-3 w-full inline-flex justify-center rounded-md border
            border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium
            text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2
            focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0
            sm:ml-3 sm:w-auto sm:text-sm"
            v-on:click="submitEdit('cancel')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /**
   * values is a map/dict/object with a key for headers that should have
   * restricted input values. The value should be a list of list pairs
   * [value, display value].
   *
   * hide: Set of headers not to show in form
   */
  props: ['row', 'headers', 'values', 'submitEdit', 'hide'],
  methods: {
    getFormValues(submitEvent) {
      const ret = [];
      for (let i = 0; i < this.row.length; i++) {
        const value = submitEvent.target[i].value;
        ret.push(value);
      }
      this.submitEdit(ret);
    },
    submitForm() {
      this.$refs.form.requestSubmit();
    },
  },
};
</script>

<style></style>
